/** A protected request already announced the expired session. */
export class SessionExpiredError extends Error {}
